import {
  LogonResponse,
  MfaAuthRequestData,
  MfaAuthenticateWithMfaRequestData,
  MfaLogonResponse,
} from '@mobi/api-types'
import { setIsCognitoContactSyncing } from '@core/Areas/Settings/Store'
import { invalidateCognitoUserQueryAsync } from '@core/Data/Account/useCognitoUser'
import { queryClient } from '@core/Data/ReactQuery'
import { post } from '@core/Services/ApiService'
import { store } from '@core/Store'
import { throwApiError } from '../Helpers/utils'

export async function triggerNonBlockingCognitoContactSync(accountNumber: number) {
  store.dispatch(setIsCognitoContactSyncing(true))
  try {
    await syncMfaContact(accountNumber)
  } catch {
    // ... no-op - ignore errors
  } finally {
    store.dispatch(setIsCognitoContactSyncing(false))
  }
  return Promise.resolve()
}

export async function syncMfaContact(accountNumber: number) {
  try {
    const response = await post<void>({
      url: '/api/bet-account/mfa/sync-contact-details',
      body: { accountNumber },
    })

    await invalidateCognitoUserQueryAsync(queryClient, accountNumber)

    return response
  } catch (error: unknown) {
    return throwApiError(error)
  }
}

export async function authenticateWithMfa(
  body: MfaAuthRequestData | MfaAuthenticateWithMfaRequestData
): Promise<LogonResponse | MfaLogonResponse> {
  const url =
    'mfaCode' in body && body.mfaCode ? '/api/mfa/authenticate-with-mfa' : '/api/mfa/authenticate'
  try {
    return await post<LogonResponse | MfaLogonResponse>({
      url,
      body,
    })
  } catch (error: unknown) {
    return throwApiError(error)
  }
}
